import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import '../css/StudentAssignmentTitlePopup.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import PopupService from '../services/PopupService';
import StudentAssignmentService from '../services/StudentAssignmentService';
import UtilityService from '../services/UtilityService';

const StudentAssignmentTitlePopup = observer((props) => {
  const {
    assignment,
    popupOptions = {},
    t
  } = props;
  const { trigger, ...restPopupOptions } = popupOptions;

  const { assignmentManager } = useContext(MobXProviderContext);

  if (!assignment) {
    return null;
  }

  const title = StudentAssignmentService.getStudentAssignmentTitle(assignment, {
    preferStudentAssignmentNickname: assignmentManager.useAssignmentNickname
  });
  const originalTitle = StudentAssignmentService.getStudentAssignmentTitle(assignment, {
    preferStudentAssignmentNickname: false
  });
  const subtitle = assignment.resourceWebSubtitle;
  const courseName = assignment.courseContentItemFriendlyName || assignment.courseContentItemName;

  const parsedTitle = UtilityService.reactHtmlParserWrapper(title).parsed;
  const parsedOriginalTitle = UtilityService.reactHtmlParserWrapper(originalTitle).parsed;
  const parsedSubtitle = UtilityService.reactHtmlParserWrapper(subtitle).parsed;
  const parsedCourseName = UtilityService.reactHtmlParserWrapper(courseName).parsed;

  const renderRow = (labelKey, value) => {
    return (
      <div className='student-assignment-title-popup-row'>
        <span className='student-assignment-title-popup-row-label'>{t(labelKey)}</span>
        <span className='student-assignment-title-popup-row-value'>{value}</span>
      </div>
    );
  };

  const content = (
    <div className='student-assignment-title-popup-content'>
      {!!title && (
        <div className='student-assignment-title-popup-title'>{parsedTitle}</div>
      )}
      {!!subtitle && renderRow('subtitle', parsedSubtitle)}
      {!!originalTitle && originalTitle !== title && renderRow('originalTitle', parsedOriginalTitle)}
      {!!originalTitle && originalTitle !== title && renderRow('nickname', parsedTitle)}
      {!!courseName && renderRow('course', parsedCourseName)}
    </div>
  );

  return PopupService.renderPopup({
    className: 'custom-popup student-assignment-title-popup',
    content,
    hoverable: false,
    on: 'hover',
    position: 'bottom left',
    trigger,
    ...restPopupOptions
  });
});
export default StudentAssignmentTitlePopup;

SatCoreRegister('StudentAssignmentTitlePopup', StudentAssignmentTitlePopup);
